<template>
  <select-field
    trigger-class="w-28"
    :model-value="modelValue"
    :options="ageOptions"
    :reduce="(option) => option.value"
    :aria-label="tr('Age')"
    :disabled="disabled"
    @update:model-value="(value) => $emit('update:modelValue', value)"
  />
</template>

<script>
import SelectField from '@/ui/components/SelectField.vue';

/** Age picker from `min` (default 18) to 65+. */
export default {
  name: 'AgeSelector',
  components: {
    SelectField,
  },
  props: {
    modelValue: {
      type: [ Number, String, null ],
      required: false,
      default: () => null,
    },
    min: {
      type: [ Number, null ],
      required: false,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue' ],
  computed: {
    ageOptions() {
      const ages = [];
      for (let i = this.min || 18; i <= 65; i++) {
        ages.push({ label: i === 65 ? '65+' : String(i), value: i });
      }

      return ages;
    },
  },
};
</script>
